import React from 'react';
import { useInstallBanner } from '../../hooks/useInstallBanner';
import { L } from '../../lib/labels';

function ShareIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="inline-block align-middle">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13" />
    </svg>
  );
}

export function InstallBanner() {
  const { showBanner, isIos, install, dismiss } = useInstallBanner();
  if (!showBanner) return null;

  if (isIos) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[200] bg-brand-600 text-white px-4 py-3 flex items-start justify-between gap-3 shadow-lg">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5">
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </div>
          <div className="min-w-0">
            <p className="text-sm font-bold leading-tight">{L.install.title}</p>
            <p className="text-xs text-brand-100 mt-0.5 leading-snug">
              No Safari, toque em <ShareIcon /> e depois em{' '}
              <span className="font-semibold">"Adicionar à Tela Inicial"</span>
            </p>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="text-white/70 hover:text-white touch-manipulation p-1 flex-shrink-0 mt-0.5"
          aria-label="Fechar"
        >
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[200] bg-brand-600 text-white px-4 py-3 flex items-center justify-between gap-3 shadow-lg">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
          </svg>
        </div>
        <div className="min-w-0">
          <p className="text-sm font-bold leading-tight">{L.install.title}</p>
          <p className="text-xs text-brand-100 truncate">{L.install.desc}</p>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={install}
          className="bg-white text-brand-700 font-bold text-sm px-3 py-1.5 rounded-lg touch-manipulation"
        >
          {L.install.install}
        </button>
        <button
          onClick={dismiss}
          className="text-white/70 hover:text-white touch-manipulation p-1"
          aria-label="Fechar"
        >
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
